// internal/AuditLogPage.jsx — Logs & Audit AYA Internal.
import { useEffect, useState } from "react";
import InternalLayout, { S, IT } from "@/internal/InternalLayout";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api/internal`;

export default function AuditLogPage() {
  const [logs, setLogs] = useState(null);
  useEffect(() => {
    fetch(`${API}/audit`, { headers: { Authorization: `Bearer ${localStorage.getItem("civ_user_token") || ""}` } })
      .then((r) => r.json()).then((d) => setLogs(d.ok ? d.logs : [])).catch(() => setLogs([]));
  }, []);
  return (
    <InternalLayout title="Logs & Audit" subtitle="Chaque action importante est tracée : utilisateur, action, données, horodatage.">
      <div style={{ ...S.card, padding: 16 }} data-testid="audit-list">
        {logs == null && <div style={{ color: IT.muted, fontSize: 13 }}>Chargement…</div>}
        {logs != null && logs.length === 0 && <div style={{ color: IT.muted, fontSize: 13 }}>Aucune action enregistrée.</div>}
        {(logs || []).map((a, i) => (
          <div key={i} style={{ display: "flex", gap: 12, fontSize: 12, padding: "7px 0", borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
            <span style={{ color: IT.green, fontWeight: 800, minWidth: 120 }}>{a.action}</span>
            <span style={{ color: IT.muted, flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{a.user}{a.details && Object.keys(a.details).length ? ` · ${JSON.stringify(a.details)}` : ""}</span>
            <span style={{ color: IT.muted }}>{new Date(a.ts).toLocaleString("fr-FR")}</span>
          </div>
        ))}
      </div>
    </InternalLayout>
  );
}
